import { defineStore } from 'pinia';

export const useBuildInfoStore = defineStore('buildInfo', {
  state: () => ({
    buildInfo: null, // 存储拼装信息
  }),
  actions: {
    setBuildInfo(info) {
      this.buildInfo = info;
    },

    getBuildInfo() {
      return this.buildInfo;
    },

    clearBuildInfo() {
      this.buildInfo = null;
    },
  },
});